import { render, staticRenderFns } from "./UserGroups.vue?vue&type=template&id=12596183&scoped=true"
import script from "./UserGroups.vue?vue&type=script&lang=js"
export * from "./UserGroups.vue?vue&type=script&lang=js"
import style0 from "./UserGroups.vue?vue&type=style&index=0&id=12596183&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12596183",
  null
  
)

export default component.exports